const VALID_OTP_LENGTH = 4;

export const validateOtpLength = (otp) => {
  return otp?.length === VALID_OTP_LENGTH;
};
